export const convertDecimalHourToHM = (
  decimalHour: number
): string | undefined => {
  if (typeof decimalHour !== 'number') {
    return undefined
  }
  const hour = Math.floor(decimalHour)
  let min = Math.floor((decimalHour - hour) * 60)
  const sec = Math.round(((decimalHour - hour) * 60 - min) * 60)
  if (sec >= 30) {
    min += 1
  }
  return `${hour}:${min.toString().padStart(2, '0')}`
}

export const convertDecimalHourToHMS = (
  decimalHour: number
): string | undefined => {
  if (typeof decimalHour !== 'number') {
    return undefined
  }
  const hour = Math.floor(decimalHour)
  let min = Math.floor((decimalHour - hour) * 60)
  let sec = Math.round(((decimalHour - hour) * 60 - min) * 60)
  if (sec === 60) {
    sec = 0
    min += 1
  }
  return `${hour}:${min.toString().padStart(2, '0')}:${sec
    .toString()
    .padStart(2, '0')}`
}

export const convertUnixToHMS = (milliseconds: number) => {
  const seconds = Math.floor(milliseconds / 1000)
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const sec = seconds % 60

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${sec.toString().padStart(2, '0')}`
}

/**
 * APIから返される小数時間（hour）を秒単位に変換する
 * 分単位で丸めてから秒換算することで、小数点誤差による1-2分のズレを防ぐ
 *
 * @param decimalHour - 小数形式の時間（例: 1.5 = 1時間30分）
 * @returns 秒単位の時間（例: 5400秒 = 90分）
 *
 * @example
 * convertDecimalHourToSeconds(1.5)  // => 5400 (90分 = 1.5時間)
 * convertDecimalHourToSeconds(0.25) // => 900  (15分 = 0.25時間)
 */
export const convertDecimalHourToSeconds = (decimalHour: number): number => {
  return Math.round(decimalHour * 60) * 60
}
